<template>
  <div class="anz-bg-black-3 anz-px-xl anz-py-m anz-my-xl anz-b-rounded">
    <div class="post">
      <a-button
        class-name="anz-link anz-block anz-fr anz-color-black-50 anz-mrn-s anz-mtn-xs"
        show-icon
        @click="close"
        icon-width="0.7142em"
        icon-height="0.7142em"
        icon-name="cross-solid"
        icon-class="anz-block"
        :style="{ opacity: '0.5' }"
      />
      <div class="anz-align-center">
        <span class="anz-strong">
          {{ $translate('post.actionResults.postResponded') }}
        </span>
        <br />
        <a-button
          class-name="anz-link anz-link-inverse anz-strong"
          :title="$translate('post.actions.showCreatedPost')"
          @click="showAfterCreate"
        >
        </a-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import useAppState from '@/composables/ui/ui'
import usePostCreate from '@/composables/post/postCreate'

export default defineComponent({
  name: 'PostSaved',
  components: {
    AButton,
  },
  setup() {
    const { lastSavedPost } = useAppState()
    const { showAfterCreate } = usePostCreate()

    const close = () => {
      const { showLastSavedPost } = useAppState()
      showLastSavedPost.value = false
    }

    return {
      lastSavedPost,
      showAfterCreate,
      close,
    }
  },
})
</script>
